import type { Transition } from 'history';
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { resources } from "@constants/hardcoded-strings";
import { ModalSizeTypes } from "@enums/modal-size-types";
import { DefaultModal } from "../../common/modals/default-modal/default-modal";

type DiscardChangesModalProps = {
    onClickContinue: (tx: Transition) => void;
    onModalClose: () => void;
    tx: Transition;
    idPrefix: string;
};

export const DiscardChangesModal = (props: DiscardChangesModalProps) => {
    const { onClickContinue, onModalClose, tx, idPrefix } = props;

    const handleContinueClick = () => {
        onClickContinue(tx);
        onModalClose();
    };

    return (
        <DefaultModal
            automationId={`${idPrefix}-modal`}
            ariaLabelledBy={`${idPrefix}-title`}
            onHide={onModalClose}
            backdrop={"static"}
            keyboard={false}
            isMaxWidth={false}
            size={ModalSizeTypes.MEDIUM}
        >
            <Modal.Header id={`${idPrefix}-title`} closeButton>
                <Modal.Title>{resources.modals.discardChanges.title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <span>{resources.modals.discardChanges.description}</span>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onModalClose}>
                    {resources.modals.discardChanges.buttons.no.label}
                </Button>
                <Button variant="primary" onClick={handleContinueClick}>
                    {resources.modals.discardChanges.buttons.yes.label}
                </Button>
            </Modal.Footer>
        </DefaultModal>
    );
};